import { atom } from 'recoil';

export const key = 'disableContentPaddings';

export const state = atom<boolean>({
    key,
    default: false,
});
